import BannerTypeSelect from './BannerTypeSelect';

export default BannerTypeSelect;
